import React from 'react';
import { FiEdit2, FiTrash2, FiEye } from 'react-icons/fi';
import axios from 'axios';
import { toast } from 'react-toastify';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const MembersList = ({ members, onView, onEdit, onDelete, searchTerm, currentUser }) => {
  const handleDelete = async (id, memberName) => {
    if (currentUser.role !== 'admin') {
      toast.error('Only administrators can delete members');
      return;
    }

    if (window.confirm(`Are you sure you want to permanently delete ${memberName}? This action cannot be undone.`)) {
      try {
        await axios.delete(`${url}/api/members/${id}`);
        onDelete();
      } catch (err) {
        console.error('Error deleting member:', err);
        const errorMsg = err.response?.data?.message || 'Delete failed';
        toast.error(errorMsg);
      }
    }
  };

  return (
    <div className="members-list-container">
      <div className="table-responsive">
        <table className="members-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Country</th>
              <th>Region</th>
              <th>District</th>
              <th>Register Type</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {members.length === 0 ? (
              <tr>
                <td colSpan="9" className="no-data">
                  {searchTerm ? 'No members found matching your search' : 'No members found'}
                </td>
              </tr>
            ) : (
              members.map(member => (
                <tr key={member._id}>
                  <td>
                    <div className="member-name">
                      <strong>{`${member.fname} ${member.mname || ''} ${member.lname}`}</strong>
                    </div>
                  </td>
                  <td>{member.email}</td>
                  <td>{member.mobile}</td>
                  <td>{member.country?.name || 'N/A'}</td>
                  <td>{member.region?.name || 'N/A'}</td>
                  <td>{member.district?.name || 'N/A'}</td>
                  <td>{member.registertype?.name || 'N/A'}
                  {member.registertype?.amount && ` - $${member.registertype.amount.toFixed(2)}`}</td>
                  
                  <td>
                    <span className={`status-badge status-${member.status || 'pending'}`}>
                      {member.status || 'pending'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button 
                        onClick={() => onView(member)} 
                        className="action-btn view-btn"
                        title="View details"
                      >
                        <FiEye />
                      </button>
                      <button 
                        onClick={() => onEdit(member)} 
                        className="action-btn edit-btn"
                        title="Edit member"
                      >
                        <FiEdit2 />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MembersList;